<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div class="map-container">
  <div class="map-frame">
    <div id="leafletmap" #leafletmap>
      <div
        class="leaflet-top leaflet-right leaflet-control-container leaflet-control-zoom leaflet-bar leaflet-control map-controls"
        fxLayout="column"
        fxLayoutAlign="start stretch"
      >
        <fa-icon
          *ngIf="location?.last_known_location"
          class="icon leaflet-control"
          role="button"
          [icon]="faCrosshairs"
          (click)="this.focusLastPosition()"
        ></fa-icon>
        <fa-icon
          *ngIf="!zoomDisabled"
          class="icon leaflet-control leaflet-control-zoom-in"
          role="button"
          [icon]="faMagnifyingGlassPlus"
          (click)="this.zoomIn()"
        ></fa-icon>
        <fa-icon
          *ngIf="!zoomDisabled"
          class="icon leaflet-control leaflet-control-zoom-out"
          role="button"
          [icon]="faMagnifyingGlassMinus"
          (click)="this.zoomOut()"
        ></fa-icon>
        <fa-icon
          *ngIf="!zoomDisabled"
          class="icon leaflet-control leaflet-control-zoom-out"
          role="button"
          [icon]="faExpand"
          (click)="this.zoomToFitAllMarkers()"
        ></fa-icon>
      </div>
    </div>
  </div>
  <div
    *ngIf="location && location?.last_known_location"
    fxLayout="row"
    class="user-position-container"
  >
    <div fxLayout="row" fxLayoutGap="12px">
      <svg
        *ngIf="taskStatus === TaskStatus.IN_PROGRESS || taskStatus === TaskStatus.CLOSED"
        class="legend-marker-pin"
        viewBox="0 0 18 24"
        width="18"
        height="24"
        aria-hidden="true"
        focusable="false"
      >
        <path
          class="pin-shape"
          [attr.d]="locationPin.path"
          [attr.transform]="locationPin.transform"
        ></path>
        <path
          class="overlay-shape"
          [attr.d]="legendOverlay.path"
          [attr.transform]="legendOverlay.transform"
        ></path>
      </svg>
      <div class="user-position-text">
        <span *ngIf="taskStatus === TaskStatus.IN_PROGRESS" i18n="user position@@userPosition"
          >Current user position (last update:
          {{ location.last_known_location?.timestamp | date: 'shortTime' }})</span
        >
        <span
          *ngIf="taskStatus === TaskStatus.CLOSED"
          i18n="Last registered position@@lastRegisteredPosition"
          >Task finished (shows last registered position)</span
        >
        <div *ngIf="taskStatus !== TaskStatus.NEW" class="location-coordinates">
          <span
            i18n-matTooltip="latitude, longitude@@latitudeAndLongitude"
            matTooltip="Latitude, Longitude"
            [cdkCopyToClipboard]="
              location.last_known_location?.lat + ' ,' + location.last_known_location?.long
            "
          >
            {{ location.last_known_location?.lat }}, {{ location.last_known_location?.long }}</span
          >
          &nbsp;
          <fa-icon
            class="icon"
            [icon]="faCopy"
            [cdkCopyToClipboard]="
              location.last_known_location?.lat + ' ,' + location.last_known_location?.long
            "
            i18n-matTooltip="copy@@copy"
            matTooltip="copy"
          ></fa-icon>
        </div>
      </div>
    </div>
  </div>
</div>
